import React, { Component } from 'react';
import PropTypes from "prop-types";
import { connect } from 'react-redux';

// import classNames from "classnames";  // nodejs library that concatenates classes
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from '@material-ui/core/Grid';

// core components
import Header from "components/Header/Header.jsx";

// core components
// import Button from "components/CustomButtons/Button.jsx";
import NewsFeed from '../../components/Article/MainFeed';
import imagesStyles from "assets/jss/material-kit-pro-react/imagesStyles.jsx";
import cardStyles from "assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.jsx"
import { cardTitle } from "assets/jss/material-kit-pro-react.jsx";

import { fetchRelatedNews } from '../../actions';

const styles = theme => ({
    ...imagesStyles,
    ...cardStyles,
    cardTitle,
    RightAlign: {float: 'right'},
    button: {
        paddingTop: '17px',
        borderRadius: 0,
        backgroundColor: '#000000'
    },
    mainContainer: {
        // height: 'calc(100vh - 155px)',
        // marginTop: '155px',
        overflow: 'scroll'
    },
    mainGrid: {
        // float: 'right',
        margin: '0 auto',
        width: '80%',
        marginTop: 0
    }
});


class RelatedArticlesPage extends Component {

    constructor(props) {
        super(props);
    }

    // componentWillMount() {
    componentDidMount() {
        const { id } = this.props.match.params;
        this.props.dispatch(fetchRelatedNews(id));
    }

    render() {
        const { classes, data } = this.props;
        const now = new Date(), 
            utcNow = new Date(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds());

        const results = data.fetchRelatedArticles.records,
            totalarticleRecords = results && results.total_records ? results.total_records : null,
            isFetching = data.fetchRelatedArticles.isFetching,
            records = !(results && results.records) ? undefined : results.records,
            queryTerm = "",
            mainGridAttributes = {
                queryTerm,
                isFetching,
                records,
                isGrant: false,
                totalRecords: totalarticleRecords,
                subjectFilters: null
            };

        let title = `Showing ${totalarticleRecords} related articles`;
        if (totalarticleRecords === 1)
            title = `Showing ${totalarticleRecords} related article`;

        return (
            <div>
                {/* <Header
                    color="transparent"
                    fixed
                    changeColorOnScroll={{
                        height: 200,
                        color: "white"
                    }}
                    // {...rest}
                /> */}

                <div className={classes.mainContainer}>
                    <Grid container spacing={40} className={classes.mainGrid}>
                        <NewsFeed 
                            data={{ ...mainGridAttributes }} 
                            title={title} 
                            yesNoClick={this.handleYesNoClick}
                            utcStart={utcNow} />
                    </Grid>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return { 
        data: state 
    }
}

RelatedArticlesPage.propTypes = {
    classes: PropTypes.object,
    match: PropTypes.object,
    data: PropTypes.object,
    totalRecords: PropTypes.number,
    queryTerm: PropTypes.string,
    isFetching: PropTypes.bool,
    records: PropTypes.array,
    dispatch: PropTypes.func,
    yesNoClick: PropTypes.func
}

const styledComponent = withStyles(styles)(RelatedArticlesPage);
export default connect(mapStateToProps)(styledComponent);



// WEBPACK FOOTER //
// ./src/views/NewsArticlesPage/RelatedArticlesPage.jsx